import { useEffect, useState } from 'react';
import ProductCard from './ProductCard';
import { apiV1 } from '../../../Auth/Interceptor';

function CustomCollectionList({ item }) {
    const [productsList, setProductsList] = useState([]);

    useEffect(() => {
        async function fetchCollectionProducts() {
            try {
                const response = await apiV1.get(`customCollection/${item.customCollectionList[0]}`);
                if(response.status === 200) {
                    setProductsList(response.data.data.product);
                }
            }
            catch(err) {
                console.log(err);
            }
        }

        item.customCollectionList[0] && fetchCollectionProducts();
    }, [item]);

    return (
        <div className='w-full flex flex-col gap-2'>
            <div className="w-full flex items-center justify-between px-2 text-[10px] leading-3">
                <h1 className='text-[#B0B0B0]'>{item.name}</h1>

                <p className='text-[#64DD17]'>See all</p>
            </div>

            <div className="px-2 grid grid-cols-2 gap-x-2 gap-y-2">
                {productsList.map(product => {
                    return (
                        <ProductCard 
                            key={product.id} 
                            product={product} 
                        />
                    )
                })}
            </div>
        </div>
    );
}

export default CustomCollectionList;
